import React from 'react'
import PropTypes from 'prop-types'
import { Statistic } from 'semantic-ui-react'
import { css } from 'aphrodite'
import moment from 'moment'
import numbro from 'numbro'
import { getTimeToTarget } from '../helpers'
import createStyles from './styles'

export class Countdown extends React.Component {
  state = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  }

  componentDidMount() {
    const targetDate = moment(this.props.to)

    this.countdown = setInterval(setState => {
      this.setState(getTimeToTarget(targetDate))
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.countdown)
  }

  render() {
    const styles = getStyles(this.props, this.context)

    return this.props.simple ? (
      <span>
        {this.state.hours}:{numbro(this.state.minutes).format('00')}:{numbro(
          this.state.seconds
        ).format('00')}
      </span>
    ) : (
      <Statistic.Group
        {...this.props}
        className={css(styles.root)}
        size="small"
        widths="4"
        items={[
          { label: 'Days', value: this.state.days },
          { label: 'Hours', value: this.state.hours },
          { label: 'Minutes', value: this.state.minutes },
          { label: 'Seconds', value: this.state.seconds },
        ]}
      />
    )
  }
}

Countdown.contextTypes = {
  theme: PropTypes.object,
}

const getStyles = createStyles(props => ({
  root: {},
}))



// WEBPACK FOOTER //
// ./src/components/Countdown.js